// One-time setup for a counter PC, generated for the signed-in temple. Each counter type gets its own
// desktop shortcut (temple logo icon) that opens its page in Chrome with --kiosk-printing, using its own
// Chrome profile in which the chosen printer is saved. So every counter prints straight to its own printer
// (e.g. Annaprasadam -> thermal, Saree -> Epson) with no print dialog, and the Windows default printer
// is never changed.
const API = process.env.REACT_APP_BACKEND_URL;

export const COUNTERS = [
  { key: "anna", name: "Annaprasadam Counter", path: "/anna/issue", how: "Press M / F / C / O - the ticket prints straight away, no print dialog." },
  { key: "protocol", name: "Protocol Darshan Counter", path: "/protocol/issue", paper: true, how: "Issue the ticket - it prints straight away, no print dialog." },
  { key: "saree", name: "Saree Counter", path: "/sarees/request", paper: true, how: "Create the token or receipt - it prints straight away, no print dialog." },
  // Identity & Passes: fixed paper per counter (portrait 4 x 6 card printer / A4 landscape), each with its own printer.
  { key: "idcard", name: "ID Card Counter", path: "/identity/duty", landscape: false,
    how: "Print a Duty Pass, Seva Card or Children Tag - it prints straight away on the 4 x 6 card, no print dialog.",
    tip: "Epson L8050 - keep the paper size A4 and feed the 3.9 x 5.2 in card in the centre of the tray; the card prints at the top centre." },
  { key: "vehicle", name: "Vehicle Pass Counter", path: "/identity/vehicle", landscape: true,
    how: "Print a Vehicle Pass - it prints straight away on A4 landscape, no print dialog.",
    tip: "Vehicle passes print on A4 paper, landscape." },
];

function setupBat(templeId, counter) {
  // Unknown temple id (e.g. Super Admin without a temple) falls back to the app logo on the server.
  const iconUrl = `${API}/api/public/temple-icon/${encodeURIComponent(templeId || "ALL")}.ico`;
  const name = `${counter.name} (Direct Print)`;
  const lines = String.raw`@echo off
setlocal
title ${counter.name} - Direct Print Setup
set "URL=https://pro.aatreya.org${counter.path}?directprint=1"
set "SHORTCUT=${name}"
set "SETNAME=${counter.name} (Print Settings)"
set "ICONURL=${iconUrl}"
set "ROOT=%LOCALAPPDATA%\AatreyaCounter"
set "KEY=${counter.key}"
set "CPROFILE=%ROOT%\%KEY%"
set "CHROME=%ProgramFiles%\Google\Chrome\Application\chrome.exe"
if not exist "%CHROME%" set "CHROME=%ProgramFiles(x86)%\Google\Chrome\Application\chrome.exe"
if not exist "%CHROME%" set "CHROME=%LOCALAPPDATA%\Google\Chrome\Application\chrome.exe"
if not exist "%CHROME%" (
  echo Google Chrome is not installed on this computer. Install Chrome and run this setup again.
  pause
  exit /b 1
)
if not exist "%CPROFILE%\Default" mkdir "%CPROFILE%\Default"

echo.
echo  ==============================================================
echo    ${counter.name} - Direct Print Setup
echo  ==============================================================
echo.
echo  Printers on this computer:
powershell -NoProfile -ExecutionPolicy Bypass -Command "$names = @(Get-Printer | Sort-Object Name | ForEach-Object Name); Set-Content -Encoding UTF8 -Path (Join-Path $env:ROOT 'printers.txt') -Value $names; $i=0; $names | ForEach-Object { $i++; '    ' + $i + '. ' + $_ }"
echo.
set "PNUM="
set /p PNUM=  Type the number of the printer for the ${counter.name} and press Enter:
powershell -NoProfile -ExecutionPolicy Bypass -Command "$n = 0; if (-not [int]::TryParse('%PNUM%', [ref]$n)) { exit 1 }; $names = @(Get-Content -Encoding UTF8 -Path (Join-Path $env:ROOT 'printers.txt')); if ($n -lt 1 -or $n -gt $names.Count) { exit 1 }; Set-Content -Encoding UTF8 -Path (Join-Path $env:ROOT 'chosen.txt') -Value $names[$n - 1]"
if errorlevel 1 (
  echo  That number is not in the list. Run the setup again.
  pause
  exit /b 1
)

${counter.paper ? `
echo.
echo  Paper in this printer:
echo     1. 150 x 210 mm sheet, portrait - Devotee copy, then Office copy (next page)
echo     8. Half A4 sheet (A5) - Devotee copy, then Office copy, one per sheet
echo     7. Full A4 sheet - Devotee copy page 1, Office copy page 2 (both at the top)
echo     6. A4 sheet, portrait - devotee copy and office copy on one page
echo     2. 6 x 4 inch card, portrait
echo     3. 6 x 4 inch card, landscape
echo     4. 6 x 4 inch card, landscape design on portrait-fed paper (turned)
echo     5. Thermal slip, 80 mm roll (like Annaprasadam)
set "PAPER=s21x15"
set "PAPERNUM="
set /p PAPERNUM=  Type a number from 1 to 8 and press Enter: 
if "%PAPERNUM%"=="2" set "PAPER=4x6"
if "%PAPERNUM%"=="3" set "PAPER=card"
if "%PAPERNUM%"=="4" set "PAPER=rot"
if "%PAPERNUM%"=="5" set "PAPER=slip"
if "%PAPERNUM%"=="6" set "PAPER=a4"
if "%PAPERNUM%"=="7" set "PAPER=half"
if "%PAPERNUM%"=="8" set "PAPER=a5"
set "URL=%URL%&paper=%PAPER%"
` : ""}
rem Save the printer inside this counter's own Chrome profile (Chrome prints to it in kiosk mode).
powershell -NoProfile -ExecutionPolicy Bypass -Command "$p = (Get-Content -Encoding UTF8 -Path (Join-Path $env:ROOT 'chosen.txt') | Select-Object -First 1).Trim(); Get-CimInstance Win32_Process | Where-Object { $_.Name -eq 'chrome.exe' -and $_.CommandLine -and $_.CommandLine.Contains($env:CPROFILE) } | ForEach-Object { Stop-Process -Id $_.ProcessId -Force -ErrorAction SilentlyContinue }; Start-Sleep -Milliseconds 800; $pf = Join-Path $env:CPROFILE 'Default\Preferences'; $state = @{ version = 2; recentDestinations = @(@{ id = $p; origin = 'local'; account = ''; capabilities = $null; displayName = $p; extensionId = ''; extensionName = ''; icon = 'print-preview:print' }); isHeaderFooterEnabled = $false; isCssBackgroundEnabled = $true; isLandscapeEnabled = ${counter.paper ? "($env:PAPER -eq 'card' -or $env:PAPER -eq 'a5')" : counter.landscape ? "$true" : "$false"}; marginsType = 0 } | ConvertTo-Json -Depth 10 -Compress; if (Test-Path $pf) { $j = Get-Content -Raw -Encoding UTF8 $pf | ConvertFrom-Json } else { $j = New-Object PSObject }; if (-not $j.printing) { $j | Add-Member -Force -NotePropertyName printing -NotePropertyValue (New-Object PSObject) }; $j.printing | Add-Member -Force -NotePropertyName print_preview_sticky_settings -NotePropertyValue ([pscustomobject]@{ appState = $state }); $j | ConvertTo-Json -Depth 100 -Compress | Set-Content -Encoding UTF8 -Path $pf; '  Printer for this counter: ' + $p"
if errorlevel 1 (
  echo  Could not save the printer for this counter.
  pause
  exit /b 1
)

powershell -NoProfile -ExecutionPolicy Bypass -Command "$ico = Join-Path $env:ROOT 'temple.ico'; try { [Net.ServicePointManager]::SecurityProtocol = [Net.SecurityProtocolType]::Tls12; Invoke-WebRequest -UseBasicParsing $env:ICONURL -OutFile $ico } catch { }; $s = (New-Object -ComObject WScript.Shell).CreateShortcut((Join-Path ([Environment]::GetFolderPath('Desktop')) ($env:SHORTCUT + '.lnk'))); $s.TargetPath = $env:CHROME; $s.Arguments = '--kiosk-printing --no-first-run --no-default-browser-check --user-data-dir=\"' + $env:CPROFILE + '\" --start-maximized --app=\"' + $env:URL + '\"'; if (Test-Path $ico) { $s.IconLocation = $ico + ',0' } else { $s.IconLocation = $env:CHROME + ',0' }; $s.Description = $env:SHORTCUT + ' - prints directly to its own printer'; $s.Save(); '  Desktop shortcut created: ' + $env:SHORTCUT; $t = (New-Object -ComObject WScript.Shell).CreateShortcut((Join-Path ([Environment]::GetFolderPath('Desktop')) ($env:SETNAME + '.lnk'))); $t.TargetPath = $env:CHROME; $t.Arguments = '--no-first-run --no-default-browser-check --user-data-dir=\"' + $env:CPROFILE + '\" --start-maximized --app=\"' + $env:URL + '\"'; if (Test-Path $ico) { $t.IconLocation = $ico + ',0' } else { $t.IconLocation = $env:CHROME + ',0' }; $t.Description = 'Print once with the print window to choose the paper size for ' + $env:SHORTCUT; $t.Save(); '  Desktop shortcut created: ' + $env:SETNAME"
if errorlevel 1 (
  echo  Could not create the desktop shortcut.
  pause
  exit /b 1
)
ie4uinit.exe -show >nul 2>&1

echo.
echo  Done. From now on:
echo    1. Open "${name}" from the desktop.
echo    2. Log in once and allow the camera once (this window remembers them).
echo    3. ${counter.how}
echo.
echo  Paper size: open "${counter.name} (Print Settings)" once, print one ticket,
echo  choose Paper size (your custom size), Margins None, Scale Default and Print.
echo  The Direct Print shortcut remembers it from then on.
echo  (Close the Direct Print window before opening Print Settings - they share one profile.)
echo  Each counter keeps its own printer. To change it, run this setup again.
${counter.tip ? `echo  Tip: ${counter.tip}` : `echo  Tip: 150 x 210 mm sheets - create a custom (User-Defined) paper size 150 x 210 mm in the printer's Printing Preferences.
echo  Tip: half A4 sheets - set the paper size to A5 in the printer's Printing Preferences.
echo  Tip: thermal printer - choose the 80mm / 3 inch roll paper size in its Printing Preferences.`}
echo.
choice /c YN /m "  Open the counter now"
if errorlevel 2 exit /b 0
start "" "%CHROME%" --kiosk-printing --no-first-run --no-default-browser-check --user-data-dir="%CPROFILE%" --start-maximized --app="%URL%"
`;
  return lines.replace(/\r?\n/g, "\r\n");
}

export function downloadCounterSetup(templeId, key = "anna") {
  const counter = COUNTERS.find((c) => c.key === key) || COUNTERS[0];
  const blob = new Blob([setupBat(templeId, counter)], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${counter.name.replace(/\s+/g, "-")}-Direct-Print-Setup.bat`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
